import React from "react";
import {
  AddBoxOutlined,
  AddCardOutlined,
  AppBlockingOutlined,
  ArrowDownwardOutlined,
  ArrowUpwardOutlined,
  AssuredWorkloadOutlined,
  BackHandOutlined,
  BarChartOutlined,
  CategoryOutlined,
  CheckOutlined,
  CompareArrowsOutlined,
  CreditCardOffOutlined,
  CurrencyExchangeOutlined,
  DeleteOutlined,
  DescriptionOutlined,
  DriveFileRenameOutlineOutlined,
  EventBusyOutlined,
  EventNoteOutlined,
  EventOutlined,
  ExpandOutlined,
  FactCheckOutlined,
  FingerprintOutlined,
  GradingOutlined,
  GroupOutlined,
  HandshakeOutlined,
  HighlightOffOutlined,
  InfoOutlined,
  InsertDriveFileOutlined,
  Inventory2Outlined,
  KeyOffOutlined,
  KeyOutlined,
  LanguageOutlined,
  LocationOnOutlined,
  LogoutOutlined,
  MailOutlined,
  ManageAccountsOutlined,
  ModeOutlined,
  NewReleasesOutlined,
  NotificationsActiveOutlined,
  NotificationsOutlined,
  PasswordOutlined,
  PercentOutlined,
  PictureAsPdfOutlined,
  SettingsOutlined,
  ShoppingCartOutlined,
  TrendingDownOutlined,
  TrendingUpOutlined,
  VerticalAlignTopOutlined,
  WalletOutlined,
} from "@mui/icons-material";
import CashbackOutlineIcon from "../../Icons/CashbackOutlineIcon";
import InsuranceOutlineIcon from "../../Icons/InsuranceOutlineIcon";
import { SxProps, Theme } from "@mui/material/styles";
import { logger } from "../helpers";
import { useLocation } from "react-router";
import EFakturaIcon from "../../Icons/EFakturaIcon";
import InvoiceTypeOutlineIcon from "../../Icons/InvoiceTypeOutlineIcon";
import BSOutlineIcon from "../../Icons/BSOutlineIcon";
import BankIdNoOutlineIcon from "../../Icons/BankIdNoOutlineIcon";
import LoanIcon from "../../Icons/LoanIcon";
import SavingsIcon from "../../Icons/SavingsIcon";
import HomeIcon from "../../Icons/HomeIcon";
import CreditCardIcon from "../../Icons/CreditCardIcon";
import ClickToPayIcon from "../../Icons/ClickToPayIcon";
import LoanRedemptionIcon from "../../Icons/LoanRedemptionIcon";
import LimitChangeIcon from "../../Icons/LimitChangeIcon";

interface Props {
  routeName?: string;
  iconSx?: SxProps<Theme>;
  consumer: string;
}

export const RouteNameToMuiIconMapper: React.FC<Props> = ({ routeName, iconSx, consumer }) => {
  const { pathname } = useLocation();
  const MuiIcon = mapFromRouteNameToMuiIcon(pathname, consumer, routeName);
  if (MuiIcon) {
    return <MuiIcon sx={iconSx} />;
  }
  return null;
};
function mapFromRouteNameToMuiIcon(pathname: string, consumer: string, routeName?: string) {
  if (!routeName) {
    logger.logError(`RouteNameToMuiIconMapper RouteName is not set path=${pathname} ${consumer}`);
  }
  switch (routeName) {
    case "MyPage2":
      return HomeIcon;
    case "MyPage2CreditCard":
      return CreditCardIcon;
    case "MyPage2CreditCardTransactions":
    case "MyPage2LoanTransactions":
    case "MyPage2SavingsAccountTransactions":
      return BarChartOutlined;
    case "MyPage2SettingsTransactionLimit":
      return VerticalAlignTopOutlined;
    case "MyPage2Bonus":
      return CashbackOutlineIcon;
    case "MyPage2CreditCardPayment":
    case "MyPage2CreditLinePayment":
    case "MyPage2SavingsAccountPayment":
      return WalletOutlined;
    case "MyPage2SavingsAccountCreateAccount":
      return AddBoxOutlined;
    case "MyPage2SavingsAccountNickName":
      return DriveFileRenameOutlineOutlined;
    case "MyPage2CreditCardLimit":
      return LimitChangeIcon;
    case "MyPage2CreditLineLimit":
      return ExpandOutlined;
    case "MyPage2CreditLineLimitIncrease":
      return ArrowUpwardOutlined;
    case "MyPage2CreditLineLimitDecrease":
    case "MyPage2LoanEquityReleasePayment":
      return ArrowDownwardOutlined;
    case "MyPage2Settings":
    case "MyPage2CreditCardSettings":
      return SettingsOutlined;
    case "MyPage2CreditCardMyCardMenu":
    case "MyPage2CreditCardBlockCard":
    case "MyPage2CreditCardBlockCardNew":
      return CreditCardOffOutlined;
    case "MyPage2CreditCardInvoiceSpa":
    case "MyPage2LoanInvoice":
      return DescriptionOutlined;
    case "MyPage2DisputeSpa":
      return NewReleasesOutlined;
    case "MyPage2CreditCardAtmLocator":
      return LocationOnOutlined;
    case "MyPage2CreditCardCurrencyConversion":
      return CurrencyExchangeOutlined;
    case "MyPage2CreditCardNewCard":
    case "MyPage2CreditCardNewCardOrder":
    case "MyPage2CreditCardNewCardOrderSettings":
      return AddCardOutlined;
    case "MyPage2CreditCardTokens":
      return WalletOutlined;
    case "MyPage2CreditCardECommercePassword":
      return ShoppingCartOutlined;
    case "MyPage2CreditCardTermination":
    case "MyPage2SavingsAccountRedemption":
      return DeleteOutlined;
    case "MyPage2CreditCardPinOverview":
    case "MyPage2CreditCardPin":
      return PasswordOutlined;
    case "MyPage2Document":
    case "MyPage2InvoiceView":
    case "MyPage2LoanEquityReleaseDocuments":
      return PictureAsPdfOutlined;
    case "PublicPortalCmsPriceList":
    case "MyPage2LoanEquityReleaseDetails":
      return InfoOutlined;
    case "MyPage2CreditCardNewWearable":
      return AddCardOutlined;
    case "MyPage2CreditCardAddOns":
    case "MyPage2LoanAddOns":
      return InsuranceOutlineIcon;
    case "CreditCardSignedDocument":
    case "LoanSignedDocument":
    case "SavingsAccountSignedDocument":
    case "MyPage2CreditCardAgreements":
    case "MyPage2LoanAgreements":
      return InsertDriveFileOutlined;
    case "MyPage2CreditCardPaymentEInvoice":
    case "MyPage2PaymentEInvoice":
      return EFakturaIcon;
    case "MyPage2CreditCardInvoiceChooseAmount":
    case "MyPage2CreditLineInvoiceChooseAmount":
      return ModeOutlined;
    case "MyPage2CreditCardInvoiceArchive":
    case "MyPage2LoanInvoiceArchive":
      return Inventory2Outlined;
    case "MyPage2CreditCardInvoiceType":
    case "MyPage2LoanInvoiceType":
      return InvoiceTypeOutlineIcon;
    case "MyPage2CreditCardBetalingsService":
    case "MyPage2LoanBetalingsService":
      return BSOutlineIcon;
    case "MyPage2PaymentTransfer":
      return CompareArrowsOutlined;
    case "MyPage2TopUp":
      return TrendingUpOutlined;
    case "ApplyLoanNew":
    case "MyPage2Loan":
    case "MyPage2Loans":
    case "MyPage2LoanDetails":
    case "MyPage2LoanApplication":
    case "MyPage2TopUpApplication":
      return LoanIcon;
    case "MyPage2LoanRedemption":
      return FactCheckOutlined;
    case "MyPage2LoanEquityReleaseRedemption":
      return LoanRedemptionIcon;
    case "MyPage2LoanCustomPayment":
      return TrendingDownOutlined;
    case "MyPage2LoanExtension":
      return EventOutlined;
    case "MyPage2LoanSkipAPay":
      return EventBusyOutlined;
    case "MyPage2RepaymentPlan":
      return EventNoteOutlined;
    case "MyPage2Mailbox":
      return MailOutlined;
    case "MyPage2ContactInfo":
      return ManageAccountsOutlined;
    case "MyPage2NotificationPreferences":
      return NotificationsOutlined;
    case "MyPage2Accesses":
      return KeyOutlined;
    case "MyPage2EmailSubscriptions":
      return BackHandOutlined;
    case "MyPage2PersonConsents":
      return GradingOutlined;
    case "Logout":
      return LogoutOutlined;
    case "MyPage2SavingsAccount":
      return SavingsIcon;
    case "MyPage2PaymentPendingPayments":
      return EventNoteOutlined;
    case "MyPage2PaymentAgreementsOverview":
      return HandshakeOutlined;
    case "MyPage2PaymentApproval":
      return CheckOutlined;
    case "MyPage2PaymentRejections":
      return HighlightOffOutlined;
    case "MyPage2PaymentRecipientRegistry":
      return GroupOutlined;
    case "MyPage2LanguageSettings":
      return LanguageOutlined;
    case "MyPage2ExternalAccountNumber":
      return AssuredWorkloadOutlined;
    case "MyPage2InvoiceAnnualStatements":
      return EventOutlined;
    case "MyPage2TaxableToOthers":
      return PercentOutlined;
    case "PublicPortalCmsProductsWildcard":
      return CategoryOutlined;
    case "MyPage2PushNotificationPreferences":
      return NotificationsActiveOutlined;
    case "MyPage2AccessesAppCode":
      return FingerprintOutlined;
    case "MyPage2AccessesDevices":
      return AppBlockingOutlined;
    case "MyPage2AccessesOpenBankingConsents":
      return KeyOffOutlined;
    case "MyPage2BankIdInfo":
      return BankIdNoOutlineIcon;
    case "MyPage2CreditCardAddToClickToPay":
    case "MyPage2CreditCardClickToPayDetails":
      return ClickToPayIcon;
  }
  logger.logError(`RouteNameToMuiIconMapper missing mapping for RouteName=${routeName} path=${pathname} ${consumer}`);
}
